import { ShoppingCart } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ROUTES } from "@/shared/model/routes";
import { Button } from "@/shared/ui/kit/button";

export function CartEmpty({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-25 px-6 min-h-full">
      <div className="size-20 rounded-full bg-muted flex items-center justify-center mb-4">
        <ShoppingCart className="size-8 text-muted-foreground" />
      </div>
      <h2 className="text-lg font-semibold mb-1">{t("cart.empty.title")}</h2>
      <p className="text-sm text-muted-foreground text-center mb-6">
        {t("cart.empty.description")}
      </p>
      <Button variant="secondary" asChild>
        <Link to={ROUTES.PRODUCTS} onClick={onClose}>
          {t("cart.empty.browseProducts")}
        </Link>
      </Button>
    </div>
  );
}
